<template>
  <v-form ref="form" @submit.prevent="submit" lazy-validation v-model="valid">
    <v-container :class="$vuetify.breakpoint.xsOnly ? '' : 'elevation-2'">
      <v-text-field
        v-if="!this.campo || this.campo === 'nombre'"
        :label="labels.nombre"
        v-model="form.nombre"
        :error-messages="errors.nombre"
        :rules="[rules.required('nombre')]"
        :disabled="loading"
      ></v-text-field>

      <v-text-field
        v-if="!this.campo || this.campo === 'clave_dgp'"
        :label="labels.clave_dgp"
        v-model="form.clave"
        :error-messages="errors.clave_dgp"
        :rules="[rules.required('clave_dgp')]"
        :disabled="loading"
      ></v-text-field>

      <v-text-field
        v-if="!this.campo || this.campo === 'clave_concentradora'"
        :label="labels.clave_concentradora"
        v-model="form.clave_concentradora"
        :error-messages="errors.clave_concentradora"
        :rules="[rules.required('clave_concentradora')]"
        :disabled="loading"
      ></v-text-field>

      <v-text-field
        v-if="!this.campo || this.campo === 'version_xml_titulos'"
        :label="labels.version_xml_titulos"
        v-model="form.version_xml_titulos"
        :error-messages="errors.version_xml_titulos"
        :rules="[rules.required('version_xml_titulos')]"
        :disabled="loading"
      ></v-text-field>

      <v-text-field
        v-if="!this.campo || this.campo === 'wsdl_url_titulos'"
        :label="labels.wsdl_url_titulos"
        v-model="form.wsdl_url_titulos"
        :error-messages="errors.wsdl_url_titulos"
        :rules="[rules.required('wsdl_url_titulos')]"
        :disabled="loading"
      ></v-text-field>

      <v-text-field
        v-if="!this.campo || this.campo === 'wsdl_usuario_titulos'"
        :label="labels.wsdl_usuario_titulos"
        v-model="form.wsdl_usuario_titulos"
        :error-messages="errors.wsdl_usuario_titulos"
        :rules="[rules.required('wsdl_usuario_titulos')]"
        :disabled="loading"
      ></v-text-field>

      <v-text-field
        v-if="!this.campo || this.campo === 'wsdl_constrasena_titulos'"
        :label="labels.wsdl_constrasena_titulos"
        v-model="form.wsdl_constrasena_titulos"
        :error-messages="errors.wsdl_constrasena_titulos"
        :rules="[rules.required('wsdl_constrasena_titulos')]"
        :disabled="loading"
      ></v-text-field>

      <v-text-field
        v-if="!this.campo || this.campo === 'version_xml_certificados'"
        :label="labels.version_xml_certificados"
        v-model="form.version_xml_certificados"
        :error-messages="errors.version_xml_certificados"
        :rules="[rules.required('version_xml_certificados')]"
        :disabled="loading"
      ></v-text-field>
    </v-container>

    <v-layout justify-end mt-2>
      <v-btn
        flat
        :disabled="loading"
        @click="$router.go(-1)"
        color="grey darken-2"
      >
        Cancelar
      </v-btn>

      <v-btn
        type="submit"
        :loading="loading"
        :disabled="loading"
        color="primary"
      >
        Guardar
      </v-btn>
    </v-layout>
  </v-form>
</template>

<script>
  import axios from 'axios'
  import { mapGetters } from 'vuex'
  import { api } from '~/config'
  import Form from '~/mixins/form'

  export default {
    mixins: [Form],

    data: () => ({
      form: {},
      campo: null
    }),

    mounted() {
      if(this.$route.params.campo) {
        this.campo = this.$route.params.campo
      } else {
        let tab = this.$route.fullPath.replace(this.$route.path, '').split('/')
        let param = decodeURI(tab[0].substr(1))
        if (
          param === 'nombre' ||
          param === 'clave_dgp' ||
          param === 'clave_concentradora' ||
          param === 'version_xml_titulos' ||
          param === 'wsdl_url_titulos' ||
          param === 'wsdl_usuario_titulos' ||
          param === 'wsdl_constrasena_titulos' ||
          param === 'version_xml_certificados'
        ) {
          this.campo = param
        }
      }

      if(this.campo) {
        this.$router.replace('#' + this.campo)
      }

      this.getInstitucion(1)
    },

    methods: {
      getInstitucion(id) {
        this.loading = true
        axios
          .get(api.path('instituciones.single', { id: id } ), {
            params: {
              campo: this.campo
            }
          })
          .then(res => {
            this.form.nombre = res.data.nombre
            this.form.clave = res.data.clave  
            this.form.clave_concentradora = res.data.clave_concentradora
            this.form.version_xml_titulos = res.data.configuracion.version_xml_titulos
            this.form.wsdl_url_titulos = res.data.configuracion.wsdl_url_titulos
            this.form.wsdl_usuario_titulos = res.data.configuracion.wsdl_usuario_titulos
            this.form.wsdl_constrasena_titulos = res.data.configuracion.wsdl_constrasena_titulos
            this.form.version_xml_certificados = res.data.configuracion.version_xml_certificados
          })
          .catch(err => {
            this.handleErrors(err.response.data.errors)
          })
          .then(() => {
            this.loading = false
          })
      },

      submit() {
        if (this.$refs.form.validate()) {
          
        }
      }
    }
  }
</script>
